module.exports = __webpack_public_path__ + "static/media/blue_underline.f714113d.svg";